import DropdownMenuItem from "ds/components/DropdownMenu/Item";

import { showDeleteConfirmation } from "./DeleteConfirmation";

type ContextsDeleteDropdownItemProps = {
  hasAttachedEntities: boolean;
  id: string;
  name: string;
  onSuccess?: () => void;
  showConfirmationCallback?: () => void;
  isDisabled?: boolean;
  tooltip?: string;
};

const ContextsDeleteDropdownItem = ({
  hasAttachedEntities,
  id,
  name,
  onSuccess,
  showConfirmationCallback: close,
  isDisabled,
  tooltip,
}: ContextsDeleteDropdownItemProps) => {
  const handleDelete = (closeDropdown?: () => void) => {
    closeDropdown?.();
    showDeleteConfirmation({
      id,
      hasAttachedEntities,
      name,
    }).then((finished) => {
      if (finished && onSuccess) {
        onSuccess();
      }
    });
  };

  return (
    <DropdownMenuItem
      onAction={() => handleDelete(close)}
      danger
      isDisabled={isDisabled}
      tooltip={tooltip}
      tooltipPlacement="left"
    >
      Delete
    </DropdownMenuItem>
  );
};

export default ContextsDeleteDropdownItem;
